import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M1.37988 16.5C1.37988 16.5 5.0099 17.16 5.3399 23.88C5.3399 23.88 4.12986 12.76 6.10986 1.75C6.11986 1.75 2.14988 5.27 1.37988 16.5Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M56.0999 16.5C56.0999 16.5 52.4699 17.16 52.1399 23.88C52.1399 23.88 53.3499 12.76 51.3699 1.75C51.3599 1.75 55.3299 5.27 56.0999 16.5Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  )
}
